// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2Eoyd","boxTitle":"Qualiphy_boxTitle__Gx2-E","box":"Qualiphy_box__1Qm7G","toggleWrap":"Qualiphy_toggleWrap__16_04"};